export { default as BaseAddressAutocomplete } from './address-autocomplete.base';
